/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { REQUEST_LIFE_CICLE } from 'interfaces/requests';

import { IExemption } from 'interfaces/Exemption';
import { IExemptionState } from './interfaces';
import { MICROSERVICES, patch } from 'api';
import endpoints from './endpoints';

export const searchExceptions = createAsyncThunk<
  void,
  any,
  { rejectValue: any }
>(
  'exception/search',
  async ({ type, document, onSuccess, onFail }, { rejectWithValue }) => {
    try {
      const result = await patch<any>(MICROSERVICES.STRATEGIES, {
        url: endpoints.agregateExceptions(),
        data: {
          itens: [
            {
              document: document,
              type: type ? type : 'INVOICE',
            },
          ],
        },
      });

      if (!result.data[0]) {
        throw new Error('Not found data');
      }
      onSuccess && onSuccess(result?.data);
    } catch (error) {
      onFail && onFail();
      console.error('error at search', error);
      return rejectWithValue(document);
    }
  },
);

export const createExceptions = createAsyncThunk<
  void,
  any,
  { rejectValue: any }
>(
  'exception/create',
  async ({ exception, onSuccess, onFail }, { rejectWithValue }) => {
    try {
      await patch<any>(MICROSERVICES.STRATEGIES, {
        url: endpoints.createException(),
        data: exception,
      });

      onSuccess && onSuccess(exception);
    } catch (error) {
      onFail && onFail(exception);
      console.error('error at create exception', error);
      return rejectWithValue(exception);
    }
  },
);

export const removeExceptions = createAsyncThunk<
  void,
  any,
  { rejectValue: any }
>(
  'exception/remove',
  async ({ exception, onSuccess, onFail }, { rejectWithValue }) => {
    try {
      await patch<any>(MICROSERVICES.STRATEGIES, {
        url: endpoints.removeException(),
        data: exception,
      });

      onSuccess && onSuccess(exception);
    } catch (error) {
      onFail && onFail(exception);
      console.error('error at inactivate exception', error);
      return rejectWithValue(exception);
    }
  },
);

const initialState: IExemptionState = {
  exemption: {} as IExemption,
  loading: REQUEST_LIFE_CICLE.IDLE,
  submitting: REQUEST_LIFE_CICLE.IDLE,
};

const exemptionSlice = createSlice({
  name: 'exemption',
  initialState,
  reducers: {
    exemptionClear: () => initialState,
  },
});

export const { exemptionClear } = exemptionSlice.actions;
export default exemptionSlice.reducer;
